exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resolution-card[data-v-f3e87f6e]{background:#174ea6;min-height:275px}.resolution-placeholder[data-v-f3e87f6e]{align-items:center;background:#174ea6;display:flex;height:170px;justify-content:center}.resolution-description[data-v-f3e87f6e]{color:#4fa3ff;min-height:50px;word-break:break-word}", ""]);

// exports
